<header class="site-header">
    <!-- header content -->
    <div class="container">
        <div class="row">
            <div class="col-md-4 header-left">
                <p>
                    <fa-icon [icon]="['fas', 'phone']" class="phone-icon"></fa-icon>
                    <a href="tel:+435030322316od.22308"> +43 (0)50303 - 22316 od. 22308</a>
                    <br>
                    <fa-icon [icon]="['fas', 'phone']" class="hidden-phone-icon"></fa-icon>
                    Mo – Do 09:00 – 14:00 Uhr
                </p>
                <p>
                    <fa-icon [icon]="['fas', 'print']"></fa-icon>
                    <a href="tel:"></a>
                </p>
                <p>
                    <fa-icon [icon]="['fas', 'envelope']" class="envelope-icon"></fa-icon>
                    <a class="header-small" href="mailto:oebak@pv.at">oebak&#64;pv.at</a>
                </p>
            </div>

            <div class="col-md-4">
                <div class="logo">
                    <a routerLink="/" title="ÖBAK" rel="home">
                        <img ngSrc="assets/images/logo_oebak.png" alt="ÖBAK" height="128"
                             width="200" priority>
                    </a>
                </div> <!-- /.logo -->
            </div>

            <div class="col-md-4 header-right">

                <div class="menu-header-container">
                    <ul id="menu-header" class="small-links">
                        <li id="menu-item-18"
                            class="menu-item menu-item-type-post_type menu-item-object-page menu-item-18">
                            <a routerLink="/kontakt" routerLinkActive="activeNavBar">Kontakt</a>
                        </li>
                        <li id="menu-item-17"
                            class="menu-item menu-item-type-post_type menu-item-object-page menu-item-17 header-small">
                            <a routerLink="/impressum" routerLinkActive="activeNavBar">Impressum</a>
                        </li>
                        <li id="menu-item-513"
                            class="menu-item menu-item-type-post_type menu-item-object-page menu-item-privacy-policy menu-item-513 header-small">
                            <a rel="privacy-policy" routerLink="/datenschutz" routerLinkActive="activeNavBar">Datenschutz</a>
                        </li>
                        <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-privacy-policy menu-item-513 header-small">
                            <a routerLink="/agb" routerLinkActive="activeNavBar">AGB</a>
                        </li>
                    </ul>
                </div>

                <div class="search-form">
                    <form name="search_form" method="get" routerLink="/search" class="search_form">
                        <input type="text" name="s" placeholder="Suchen..." title="Suchen..." class="field_search">
                    </form>
                </div>
            </div>
        </div>
    </div> <!--container-->

    <div class="nav-bar-main" role="navigation">
        <div class="container">
            <nav class="main-navigation clearfix visible-md visible-lg" role="navigation">
                <ul id="menu-top-1" class="main-menu sf-menu sf-js-enabled sf-arrows">
                    <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home menu-item-23">
                        <a routerLink="/home" routerLinkActive="activeNavBar">Home</a></li>
                    <!-- TODO: sollte / statt /home sein -->
                    <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1004">
                        <a routerLink="/online-lehrgaenge" routerLinkActive="activeNavBar">Online-Lehrgänge</a>
                    </li>
                    <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-21">
                        <a routerLink="/events" routerLinkActive="activeNavBar">Anmeldung / Termine</a>
                    </li>
                    <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1013">
                        <a routerLink="/kosten-storno" routerLinkActive="activeNavBar">Zahlungsbedingungen <fa-icon [icon]="['fas', 'angle-down']" class="ml-2"></fa-icon></a>
                        <ul class="submenu">
                            <li>
                                <a routerLink="/storno-umbuchung" routerLinkActive="activeNavBar">Storno & Umbuchung</a>
                            </li>
                            <li>
                                <a routerLink="/widerruf" routerLinkActive="activeNavBar">Widerruf</a>
                            </li>
                        </ul>
                    </li>
                    <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-20">
                        <a routerLink="/anmeldung" routerLinkActive="activeNavBar">Kontakt</a>
                    </li>
                    <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-19">
                        <a routerLink="/faq" routerLinkActive="activeNavBar">FAQ</a>
                    </li>
                </ul>
            </nav> <!-- /.main-navigation -->
        </div> <!-- /.container -->
    </div> <!-- /.nav-bar-main -->

</header>
